interface BordersProps {
  name: string;
  value: string;
}

const borders: BordersProps[] = [
  {
    name: 'none',
    value: 'var(--radius-none, 0rem)',
  },
  {
    name: 'xs',
    value: 'var(--radius-xs, 0.25rem)',
  },
  {
    name: 'sm',
    value: 'var(--radius-sm, 0.5rem)',
  },
  {
    name: 'md',
    value: 'var(--radius-md, 0.75rem)',
  },
  {
    name: 'lg',
    value: 'var(--radius-lg, 1rem)',
  },
  {
    name: 'xl',
    value: 'var(--radius-xl, 1.5rem)',
  },
  {
    name: '2xl',
    value: 'var(--radius-2xl, 1.75rem)',
  },
  {
    name: 'capsule',
    value: 'var(--radius-capsule, 62.4375rem)',
  },
];

export default borders;
